<!-- mat-progress-bar-->
<mat-progress-bar *ngIf="apiService.loading$ | async" class="progress" mode="indeterminate"></mat-progress-bar>
<router-outlet></router-outlet>